import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    gotIt: 'Got it',
  },
  de: {
    gotIt: 'Verstanden',
  },
});
